module.exports = __webpack_public_path__ + "static/davidAndCar-6984bedf49df4ada42944b74da895681.png";